import { Box, Stack } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import GuestReviewScoreHint from './GuestReviewScoreHint';

export default function GuestPublicProfileRow({
    averageRating,
    reviewCount,
    to,
}: {
    averageRating?: number | null;
    reviewCount?: number;
    to: string;
}) {
    if (!reviewCount) return null;

    return (
        <Stack
            direction='row'
            alignItems='center'
            spacing={1.5}
            flexWrap='wrap'
            useFlexGap
            sx={{ mb: 2 }}
        >
            <GuestReviewScoreHint
                averageRating={averageRating}
                reviewCount={reviewCount}
            />
            <Box
                component={RouterLink}
                to={to}
                sx={{
                    color: 'inherit',
                    textDecoration: 'underline',
                    textUnderlineOffset: '3px',
                    fontSize: 12,
                    fontWeight: 700,
                    transition: 'color 0.2s ease',
                    '&:hover': { color: 'secondary.main' },
                }}
            >
                Public profile
            </Box>
        </Stack>
    );
}
